// src/components/SearchProgram.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuildingColumns,
  faLocationDot,
  faFile,
} from '@fortawesome/free-solid-svg-icons';
import StaticData from './StaticData';

const SearchProgram = ({ program }) => {
  const degree = program.degreeDescriptionShort
    ? program.degreeDescriptionShort === 'CERT'
      ? ', Certificate'
      : `, ${program.degreeDescriptionShort}`
    : program.acadPlanType === 'MIN'
      ? ', Minor'
      : null;

  const owners = [];
  if (program.owners.length > 0) {
    program.owners.forEach((programOwner) => {
      if (
        owners.filter(
          (owner) => owner.collegeAcadOrg === programOwner.collegeAcadOrg
        ).length === 0
      ) {
        owners.push({
          collegeAcadOrg: programOwner.collegeAcadOrg,
          collegeDescription: programOwner.collegeDescription,
        });
      }
    });
  }

  return (
    <>
      <div className="fs-6 fw-bold">
        {program.acadPlanDescription}
        {degree}
      </div>
      {program.acadSubPlanCode && (
        <div className="fw-bold">
          {program.acadSubPlanDescription}
          <span className="subplan-tag ms-1">Subplan</span>
        </div>
      )}
      <div className="text-gray-6 d-flex align-items-start font-small">
        <FontAwesomeIcon
          icon={faBuildingColumns}
          className="me-1 text-gray-6"
          width="16px"
          style={{ marginTop: '3px' }}
        />
        {owners.map((owner, index) => (
          <span key={owner.collegeAcadOrg}>
            {owner.collegeDescription}
            {index !== owners.length - 1 && ', '}
          </span>
        ))}
      </div>
      {Array.isArray(program.campusesOffered) && program.campusesOffered.length > 0 && (
        <div className="text-gray-6 d-flex align-items-center font-small" style={{ whiteSpace: 'nowrap' }}>
          <FontAwesomeIcon
            icon={faLocationDot}
            className="me-1 text-gray-6"
            width="16px"
          />
          {program.campusesOffered
            .map((campus) => {
              const campusFound =
                typeof StaticData !== 'undefined' &&
                StaticData.campusUndergradList
                  ? StaticData.campusUndergradList.find(
                      (campusUndergrad) => campusUndergrad.value === campus.campusCode
                    )
                  : null;
              return campusFound?.label || campus.campusCode;
            })
            .join(', ')}
        </div>
      )}
      <div className="text-gray-6 d-flex align-items-center font-small">
        <FontAwesomeIcon
          icon={faFile}
          className="me-1 text-gray-6"
          width="16px"
        />
        {program.acadPlanCode}
        {program.acadSubPlanCode && <span> / {program.acadSubPlanCode}</span>}
      </div>
    </>
  );
};

export default SearchProgram;
